import { FormBlockAction } from "../schema";
import { Form } from "../types";
import { copy as copyFieldBlock } from "../../Field/lib/copy";

export const copy: Form["copy"] = (block) => ({
  ...block,
  config: {
    ...block.config,
    id: undefined,
    storageCreatedFromInterfaces: undefined,
    triggers: block.config.triggers.map((trigger) => ({
      ...trigger,
      config: { ...trigger.config, id: undefined },
    })) as FormBlockAction[],
  },
  children: block.children.map(copyFieldBlock),
});
